import React from "react";

import "./App.css";

import { useMediaQuery } from "./utility/utility";
import AutoVideo from "./components/AutoVideo";

const comingSoon = "https://calada-cigars.s3.amazonaws.com/logoAnimation_final1.mp4";
const comingSoonMobile = "https://calada-cigars.s3.amazonaws.com/logoAnimation_final1_mobile.mp4";


const App = () => {
  let SCREEN_XS = useMediaQuery("(max-width: 500px)"); 
  let SCREEN_M = useMediaQuery("(min-width: 501px)"); 
  
  return (
    <div className="app">
      { SCREEN_XS &&
        <div className="main-content">
          <div className="coming-soon">
            <AutoVideo source={comingSoonMobile}/>
          </div>
        </div>
      }

      { SCREEN_M &&
        <div className="main-content">
          <div className="coming-soon">
            <AutoVideo source={comingSoon}/>
          </div>
        </div>
      }


      {/* <div className="main-content">
        <div className="coming-soon">
          <AutoVideo source={comingSoon}/>
        </div>
      </div> */}
    </div>
  );
}

export default App;